import React from 'react';

interface FormModalProps {
    title: string;
    subtitle?: React.ReactNode;
    onClose: () => void;
    onSave?: () => void;            // sin onSave el modal es solo de lectura (botón "Cerrar")
    saving?: boolean;
    saveLabel?: string;
    error?: React.ReactNode;
    size?: 'sm' | 'lg' | 'xl';
    children: React.ReactNode;
}

// Modal con el estilo de las pantallas (encabezado, error, cuerpo y botones)
const FormModal = ({ title, subtitle, onClose, onSave, saving = false, saveLabel = 'Guardar', error, size, children }: FormModalProps) => (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={() => !saving && onClose()}>
        <div className={`modal-dialog modal-dialog-scrollable ${size ? `modal-${size}` : ''}`} onClick={(e) => e.stopPropagation()}>
            <div className="modal-content border-0">
                <div className="modal-header">
                    <div>
                        <h5 className="modal-title mb-0">{title}</h5>
                        {subtitle && <div className="text-muted small">{subtitle}</div>}
                    </div>
                    <button type="button" className="btn-close" onClick={onClose} disabled={saving} />
                </div>

                <form
                    onSubmit={(e) => { e.preventDefault(); if (onSave && !saving) onSave(); }}
                    style={{ display: 'contents' }}
                >
                    <div className="modal-body">
                        {error && (
                            <div className="alert alert-danger d-flex align-items-start gap-2 py-2">
                                <i className="bi bi-exclamation-circle mt-1" />
                                <div className="small">{error}</div>
                            </div>
                        )}
                        {children}
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-secondary" onClick={onClose} disabled={saving}>
                            {onSave ? 'Cancelar' : 'Cerrar'}
                        </button>
                        {onSave && (
                            <button type="submit" className="btn btn-primary" disabled={saving}>
                                {saving
                                    ? <><span className="spinner-border spinner-border-sm me-1" /> Guardando...</>
                                    : <><i className="bi bi-check-lg me-1" /> {saveLabel}</>}
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    </div>
);

export default FormModal;
